
import { Component, Vue, Prop } from 'vue-property-decorator'

import AppContainer from '@/components/AppContainer.vue'
import AppLoading from '@/components/AppLoading.vue'
import AppTab from '@/components/AppTab.vue'

interface TabData {
    id: string
    text: string
    path: string
}

@Component({
    components: {
        AppContainer,
        AppLoading,
        AppTab,
    },
})

export default class AppHeader extends Vue {
    public tabs: TabData[] = [
        {
            id: 'apps',
            text: 'Apps',
            path: '/',
        },
        {
            id: 'queries',
            text: 'Queries',
            path: '/queries',
        },
        {
            id: 'integrations',
            text: 'Integrações',
            path: '/integrations',
        },
        {
            id: 'partners',
            text: 'API',
            path: '/partners',
        },
    ]

    get isLoading(): boolean {
        return this.$store.state.home.isLoading
    }

    get routePath(): string {
        return this.$route.path
    }

    public mounted() {
        this.$store.dispatch('updateCanRunQueries')
    }

    public showTab(tabId: string): boolean {
        if (tabId === 'queries') {
            return this.$store.state.auth.canRunQueries
        }

        return true
    }

    public redirect(tabPath: string) {
        this.$router.push(tabPath)
    }
}
